import { useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { useEventHandler } from '../../../../hooks/useEventHandler';
import { Option } from '../../../../types';
import { useSignatureTemplates } from '../useSignatureTemplates';

export const useSignatureTemplateSearch = (envelopeId: string) => {
  const [inputValue, setInputValue] = useState('');
  const [search, setSearch] = useState('');

  const debouncedSetSearch = useDebouncedCallback(setSearch, 300);

  const onInputChange = useEventHandler((value: string) => {
    setInputValue(value);
    debouncedSetSearch(value);
  });

  const { templates, isLoading } = useSignatureTemplates(envelopeId, {
    search,
  });

  const options: Option<string>[] = useMemo(
    () => (templates ?? []).map((t) => ({ label: t.title, value: t.id })),
    [templates],
  );

  return { options, isLoading, inputValue, onInputChange };
};
